import httpService from '@/api/APIService.js'

var service = {};
//马来西亚活动id
service.MalaysiaActivityId = '23083f680793459e84b1c9c99048cf00';
/**
 * 获取微信签名
 * @param vm
 */
service.getWechatSignInfo = function(vm){
  return httpService.get(vm,'webChat/jsSignInfo');
};
/**
 * 刷新微信签名
 * @param vm
 */
service.refreshWeiXinJSSignInfo = function(vm){
  return httpService.get(vm,'webChat/refreshToken');
};
/**
 * 通过活动id和报名手机号获取客户信息
 * @param vm
 * @param activityId
 * @param mobile
 * @returns {*}
 */
service.getInformationVO = function (vm, activityId, mobile,countryCode) {
  var data = {
    activityId: activityId,
    mobile: mobile,
    areaCode: countryCode,
  };
  return httpService.get(vm, 'inf/getInformationVO', data);
};
/**
 * 获取国际区号
 * @param vm
 * @returns {*}
 */
service.getCountryInfoPhoneList = function (vm) {
  var data = {
    queryStr:vm.queryStr
  }
  return httpService.brcGet(vm, 'country/getCountryInfoPhoneList', data);
};
/**
 * 获取编码数据
 * @param vm
 * @param code
 * @returns {*}
 */
service.getByCodeValueModel = function (vm,code) {
  var data = {
    code:code
  }
  return httpService.brcGet(vm, 'npst/getByCodeValueModel', data);
};
/**
 * erp获取国际区号
 * @param vm
 * @returns {*}
 */
service.getErpCountryInfoPhoneList = function (vm) {
  var data = {
    queryStr:vm.queryStr
  }
  return httpService.get(vm, 'country/getCountryInfoPhoneList', data);
};
/**
 * 保存客户资料
 * @param vm
 * @param vo
 * @returns {*}
 */
service.saveInformationVO = function (vm, vo) {
  return httpService.post(vm, 'inf/saveInformationVO', vo);
};

/**
 * 获取行业类型
 * @param vm
 * @param levelType  COMPANY_LEVEL 公司行业类型
 * @returns {*}
 */
service.getLevelMap = function (vm, levelType) {
  var data = {
    levelType: levelType
  };
  return httpService.get(vm, 'level/getLevelMapByLevel', data);
};
/**
 * 校验评价手机号码
 * @param vm
 * @param trackId 面谈记录id
 * @param mobile 手机号码
 * @returns {*}
 */
service.checkMobile = function (vm, trackId, mobile) {
  var data = {
    trackId: trackId,
    mobile: mobile
  };
  return httpService.get(vm, 'track/checkMobile', data);
};

/**
 * 保存客户评价
 * @param vm
 * @param trackId 面谈记录id
 * @param contactEvaluate 客户评价
 * @param contactFeedback 评价反馈
 * @returns {*}
 */
service.saveEvaluate = function (vm, trackId, contactEvaluate, contactFeedback) {
  var data = {
    trackId: trackId,
    contactEvaluate: contactEvaluate
  };
  if (contactFeedback) {
    data.contactFeedback = contactFeedback;
  }
  return httpService.get(vm, 'track/saveEvaluate', data);
};


/**
 * 模糊查询获取公司名称
 * @param vm
 * @param companyName 公司名称（模糊查询）
 * @param mobile 电话号码
 * @returns {*}
 */
service.getNewList = function (vm, companyName, mobile) {
  var data = {
    companyName: companyName
  };
  if (mobile) {
    data.mobile = mobile;
  }
  return httpService.get(vm, 'company/newList', data);
};

/**
 * 精准查询获取公司数据
 * @param vm
 * @param companyName 公司名称
 * @param contactName 填报人姓名
 * @param mobile 手机号
 * @returns {*}
 */
service.getCompany = function (vm, companyName, contactName, mobile) {
  var data = {
    companyName: companyName
  };
  if (contactName) {
    data.contactName = contactName;
  }
  if (mobile) {
    data.mobile = mobile;
  }
  return httpService.get(vm, 'company/getCompany', data);
};

/**
 * 通过活动id和报名手机号获取客户信息(需验证码)
 * @param vm
 * @param activityId 活动id
 * @param mobile 客户手机号
 * @param verifyCode 验证码
 * @returns {*}
 */
service.getInformationVOByVerifyCode = function (vm, activityId, mobile, verifyCode,countryCode) {
  var data = {
    activityId: activityId,
    mobile: mobile,
    verifyCode: verifyCode,
    areaCode:countryCode
  };
  return httpService.get(vm, 'inf/getInformationVOByVerifyCode', data);
};

/**
 * 发送验证码
 * @param vm
 * @param mobile
 * @returns {*}
 */
service.sendMobileVerifyCode = function (vm, mobile,countryCode) {
  var data = {
    mobile: mobile
  };
  if(!countryCode || countryCode == '86'){
    countryCode = ''
  }
  data.countryCode = countryCode
  return httpService.get(vm, 'inf/sendMobileVerifyCode', data);
};

/**
 * 活动详情
 * @param vm
 * @param activityId 活动id
 * @param type 渠道类型
 * @param activitySignId 活动报名id
 * @returns {*}
 */
service.getChannelActivityDetail = function (vm,activityId,type,activitySignId) {
  var data = {
    activityId:activityId,
    type:type
  };
  if(activitySignId){
    data.activitySignId = activitySignId;
  }
  return httpService.brcGet(vm, 'activity/contactsDetail', data);
};

/**
 * 渠道活动详情
 * @param vm
 * @param channelId 渠道id
 * @returns {*}
 */
service.getNewLinkContactsDetail = function (vm,channelId,activitySignId,payType) {
  var data = {
    channelId:channelId,
    payType:payType
  };
  if(activitySignId){
    data.activitySignId = activitySignId;
  }
  return httpService.brcGet(vm, 'activity/getNewLinkContactsDetail', data);
};
/**
 * 扫码支付成功
 * @param vm
 * @param orderId 订单id
 * @returns {*}
 */
service.polypaySuccess = function (vm,orderId) {
  var data = {
    orderId:orderId
  };
  return httpService.brcGet(vm, 'polypay/success', data);
};
/**
 * 发送验证码
 * @param vm
 * @param mobile 手机号
 * @param sign
 * @param timeStamp
 * @param countryCode 区号 非必填，日本手机号填
 * @returns {*}
 */
service.sendChannelValidate = function (vm,mobile,sign,timeStamp,countryCode) {
  var data = {
    mobile:mobile,
    sign:sign,
    timestamp:timeStamp
  };
  if(!countryCode || countryCode == '86'){
    data.countryCode = '';
  }else{
    data.countryCode = countryCode;
  }
  return httpService.brcPost(vm,'activity/sendMessageToGlobe',data);
};
/**
 * 获取国际区号
 * @param vm
 * @returns {*}
 */
service.getCountryInfoPhoneList = function (vm) {
  var data = {
    queryStr:vm.queryStr
  }
  return httpService.brcGet(vm, 'country/getCountryInfoPhoneList', data);
};
/**
 * 渠道活动报名
 * @param vm
 * @param activityId 活动Id  必须
 * @param verifyCode 验证码
 * @param type 渠道类型
 * @param activityModel
 */
service.activityShareSignUp = function (vm,activityId,verifyCode,type,activityModel) {
  var data = {
    activityId:activityId,
    type:type,
    fromErp:true
  };
  if(verifyCode){
    data.verifyCode = verifyCode
  }
  return httpService.brcPost(vm,'activity/shareSignup',activityModel,data);
};

/**
 * 获取支付链接
 * @param vm
 * @param activitySignId 活动报名Id  必须
 */
service.stripePay = function (vm,activitySignId,channelId) {
  var data = {
    channelId,
    activitySignId
  };
  return httpService.brcPost(vm,'activity/playPayment',data);
};
/**
 * 获取mpt支付链接
 * @param vm
 * @param activitySignId 活动报名Id  必须
 */
// service.mptStripePay = function (vm,activitySignId) {
//   var data = {
//     payType:'mpt',
//     activitySignId
//   };
//return httpService.brcGet(vm,'activity/stripePay',data);
//   return httpService.brcPost(vm,'activity/playPayment',data);
// };
/**
 * 企业客户-获取编码数据源
 * @param vm
 * @param codeList
 * @returns {*|Promise<*>|void}
 */
service.getValuesByCode = function (vm, codeList) {
  var data = {
    code:'COMPANY_CONTACT_STAFF_NUM_RANGE',
  };
  
  return httpService.get(vm, "code/getValuesByCode", data);
};
export default service;



// WEBPACK FOOTER //
// ./src/api/customerService.js